




















import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop() private label!: string;
  @Prop() private type!: string;
  @Prop({ default: 'bg-orange' }) private bgColour!: string;
  @Prop({ default: 'hover:bg-orange-darker' }) private hoverBgColour!: string;
  @Prop({ default: 'text-white' }) private textColour!: string;
  @Prop({ default: 'hover:text-white' }) private hoverTextColour!: string;
  @Prop() private border!: string;
  @Prop() private borderColour!: string;
  @Prop({ default: false }) private loading!: boolean;

  private handleClick() {
    if (!this.loading) {
      this.$emit('click');
    }
  }
}
